<template>
<footer class="footer-mobile">
    <ul>
        <li>
            <v-btn flat icon :class="this.deviceClass" :to="{name: 'Home'}" :ripple="false">
                <v-icon>SC-home</v-icon><span>{{ $t('drawer.layout.menu')[0] }}</span>
            </v-btn>
        </li>
        <li>
            <v-btn flat icon :class="this.deviceClass" :to="{name: 'Explorar'}" :ripple="false">
                <v-icon>SC-explore</v-icon><span>{{ $t('drawer.layout.menu')[1] }}</span>
            </v-btn>
        </li>
        <li>
            <v-btn flat icon :class="this.deviceClass" :to="{name: 'Busca'}" :ripple="false">
                <v-icon>SC-search</v-icon><span>{{ $t('drawer.layout.menu')[2] }}</span>
            </v-btn>
        </li>
        <li>
            <v-btn flat icon :class="this.deviceClass" :to="{name: 'Favoritos'}" :ripple="false">
                <v-icon>SC-library</v-icon><span>{{ $t('drawer.layout.menu')[3] }}</span>
            </v-btn>
        </li>
    </ul>
</footer>
</template>

<script>
import bus from '@/utils/bus'

export default {
	name: 'footerMobile',
	components: {
		loading: true,
	},
	data() {
		return {
			deviceClass: null,
			screen: {
				width: null,
				height: null
			},
		}
	},
	created() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	mounted() {
		bus.$emit('loading', false)
	},
	methods: {
		menu() {
			bus.$emit('menu', true)
		},
		handleResize() {
			var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			var ratio = window.devicePixelRatio || 1;
			this.screen = {
				width: window.screen.width * ratio,
				height: window.screen.height * ratio
			};

			if (iOS && screen.width == 1125 && screen.height === 2436) {
				this.deviceClass = 'iphoneX';

			} else {
				this.deviceClass = '';
			}
		}
	}
}
</script>

<style lang="scss">
@import "../assets/css/_variables";

@media only screen and (min-width: 1025px) {
    .footer-mobile {
        display: none;
    }
}

@media only screen and (max-width: 720px) {
    .footer-mobile {
        span {
			position: absolute;
			top: 15px;
			width: 100%;
			font-size: 10px;
			text-align: center;
			left: -8px;
		}
		.v-btn .v-btn__content .v-icon{
			margin-top: -10px;
		}
    }
}

.footer-mobile {
	.v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
		background-color: transparent !important;
	}
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 50px;
    padding-bottom: constant(safe-area-inset-bottom);
    background: #f0f0f0;
    background: rgb(235, 235, 235);
    background-color: rgba(#f5f5f8, 0.75) !important;
    -webkit-backdrop-filter: blur(10px)contrast(.8);
    backdrop-filter: blur(10px)contrast(.8);

    @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution:.001dpcm) {
        background-color: rgba(#f5f5f8, 0.97) !important;
    }

    padding: 0;
    margin: 0;
    z-index: 100000;

    span {
        margin-left: 8px;
    }

    .v-btn--icon:before {
        border-radius: 0 !important;
    }

    ul {
        list-style: none;
        padding: 0;
        transition: all 0.3s ease;

        li {
            float: left;
            width: 25%;
            transition: all 0.3s ease;

            .v-btn {
                width: 100%;
                min-height: 50px;
                min-height: calc(env(safe-area-inset-bottom) + 50px);
                padding-bottom: env(safe-area-inset-bottom);
                transition: all 0.3s ease;
                margin: 0;
                color: $darkgray;

                &.v-btn--active {
                    color: $primary;
                }

                :before {
                    border-radius: 0;
                }
            }

            .iphoneX {
                min-height: 65px !important;
                padding-bottom: 15px !important;
            }
        }
    }
}
</style>
